import CSSModules from 'react-css-modules';
import { injectIntl, intlShape } from 'react-intl';

import getDisplayName from 'shared/utils/get-component-display-name';


export function WixConnect(styles) {
  return function (WrappedComponent) {

    if (styles) {
      WrappedComponent = CSSModules(styles, {
        allowMultiple: true,
        errorWhenNotFound: false,
      })(WrappedComponent);
    }

    @injectIntl
    class ConnectWixStuff extends React.Component {

      static displayName = `ConnectWixStuff(${getDisplayName(WrappedComponent)})`;

      static propTypes = {
        appSettings: React.PropTypes.object,
        intl: intlShape,
      };

      static contextTypes = {
        appSettings: React.PropTypes.object,
      };

      render() {
        const { appSettings } = this.context;
        const { intl, appSettings: propsSettings } = this.props;

        const props = _.assign({}, this.props, {
          appSettings: propsSettings || appSettings,
          intl,
        });

        return <WrappedComponent {...props} />;
      }
    }

    return ConnectWixStuff;
  };
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/utils/wix-connect.js